import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

export default class IconButton extends React.Component {
    render() {
        const classes = getComponentClasses('icon-button', this.props.variations);
        const ButtonType = this.props.href ? 'a' : 'button';
        const attrs = this.props.isDisabled ? { 'data-disabled': true } : {};

        attrs.type = this.props.isSubmit ? 'submit' : 'button';

        if (this.props.href) {
            attrs.href = this.props.href;
        }

        if (this.props.title) {
            attrs.title = this.props.title;
        }

        return (
            <ButtonType className={classes} {...attrs} onClick={this.getClickHandler()}>
                {this.props.children}
            </ButtonType>
        );
    }

    getClickHandler() {
        if (this.props.isDisabled) {
            return _ => _;
        }

        return this.props.onClick;
    }
}

IconButton.propTypes = {
    variations: PropTypes.array,
    href: PropTypes.string,
    title: PropTypes.string,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    isSubmit: PropTypes.bool,
};

IconButton.defaultProps = {
    variations: [],
    isDisabled: false,
    title: null,
    href: null,
    onClick: function() {},
    isSubmit: false,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/IconButton.jsx